import { dietDayNumber, localDateKey } from './calendar'
import type { AthleteProfile, Preferences } from './types'

export function overloadCycle(profile: AthleteProfile, preferences: Preferences) {
  const every = Math.max(1, preferences.overloadEveryWeeks || 4)
  const startedOn = preferences.overloadStartedOn || profile.dietStartedOn
  const day = dietDayNumber(startedOn, localDateKey())
  if (!day) return { configured: false, due: false, programWeek: 0, cycleWeek: 0, every, weeksUntil: every }
  const programWeek = Math.ceil(day / 7)
  const cycleWeek = ((programWeek - 1) % every) + 1
  return {
    configured: true,
    due: cycleWeek === every,
    programWeek,
    cycleWeek,
    every,
    weeksUntil: every - cycleWeek,
  }
}
